export { default as DiscordIcon } from '~icons/ic/baseline-discord';
